const defaultVersion: string = '3.0';

export const getVideoUrl = (videoUrl: string, version?: string) => {
  return `${videoUrl}?rev=${version || defaultVersion}`;
};

export const getDefaultExerciseVersion = () => {
  return defaultVersion;
};
